// import external dependencies
/* eslint-disable */
import "jquery"
import 'lightgallery';

import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-pl';
import moment from "moment";
import slick from "slick-carousel";
// Import everything from autoload
import "./autoload/_foundation.js"

datepickerFactory($);
datepickerJAFactory($);
$(window).load(function () {
	if ($('.height-js .link-post').length >= 1) {
		let heightColumn = $('.height-js .link-post').height();
		$('.default-js-height').css({height: heightColumn});
	}

	let heightHeader = $('.header').height();
	let heightHeaderBrand = $('.height-logo').height();
	let wind = $(window).width();
	let paddingTopHeader = 0;
	if ($('.block-gallery .slick-list').length >= 1) {
		let gal = $('.block-gallery .slick-list').position();
		$('.block-gallery__title').css({left: gal.left});
	}


	if (wind > 922) {
		paddingTopHeader = 30;
	} else {
		paddingTopHeader = 80;
	}
	if (heightHeader < heightHeaderBrand) {
		$('.height-padding-top').css({paddingTop: heightHeaderBrand + paddingTopHeader + 'px'});
	} else {
		$('.height-padding-top').css({paddingTop: heightHeaderBrand + paddingTopHeader + 'px'});
	}

	if (wind > 922) {
		let heightNav = $('.padding-top-js').height();
		let newTopPadding = (heightHeaderBrand / 2) - (heightNav / 2);
		$('.padding-top-js').css({paddingTop: newTopPadding});
	} else {
		$('.padding-top-js').css({paddingTop: 0});
	}

	if ($($('.btn-burger').length >= 1)) {
		let topOnReady = $('.btn-burger').position(),
			leftOnReady = $('.btn-burger').position();
		$('.menu-main-menu-container').css({top: leftOnReady.top, left: topOnReady.left});
	}
});
const windRady = $(window).width();

function onClickOpenTab() {
	if ($('.section-repertuar__spekt--btn-kup').length >= 1) {
		$('.event-date-storage').on('click', function (e) {
			if (e.target.className == 'section-repertuar__spekt--btn-kup' || e.target.className == 'img-kup-bilet') {
				e.preventDefault();
				let linkBilet = $(this).find('.section-repertuar__spekt--btn-kup').attr('data-href-link-kup');
				if ($(this).attr('data-href-link-kup') != '') {
					window.open(linkBilet, '_blank');
				}
			}
		});
	}
}

jQuery(document).ready(() => {
	onClickOpenTab();
	if ($('.block-left-post a').length < 1) {
		$('.not-find-spekt').addClass('show');
	}

	if (localStorage.getItem('date-event') && $('.default-date').length >= 1) {
		$('.default-date').attr('data-default-date', localStorage.getItem('date-event'));
	}

	$('.title-text-link').on('click', function () {
		$(this).toggleClass('clicked');
		$('.title-text-link__block--text').toggleClass('show');
	})
	$('.barakah-spektakle .art-item').each(function () {
		if ($(this).hasClass('aktualne')) {
			$(this).show();
		}
	});
	if ($('.custom-tabs .tabs-title').length >= 1) {
		if ($('.art-archive-page').length >= 1) {
			let atrSlug = $('.art-archive-page').attr('data-art-slug');
			if (atrSlug) {
				$('.custom-tabs .tabs-title').each(function () {
					let slug = $(this).attr('data-slug-cat');
					if (slug == atrSlug) {
						$(this).addClass('is-active');
					} else {
						$(this).removeClass('is-active');
					}
				});
				$('.art-item').each(function () {
					if (!$(this).hasClass(atrSlug)) {
						$(this).hide();
					} else {
						$(this).show();
						$(this).removeClass('hidden-block');
					}
				})
			}
		}
		$('.custom-tabs .tabs-title').on('click', function () {
			let slug = $(this).attr('data-slug-cat');
			$('.custom-tabs .tabs-title').removeClass('is-active');
			$(this).addClass('is-active');
			$('.art-item').each(function () {
				if (!$(this).hasClass(slug)) {
					$(this).hide();
				} else {
					$(this).show();
				}
			})
		});
	}


	$('.barakah-spektakle .custom-tabs .tabs-title').on('click', function () {
		let slug = $(this).attr('data-slug-cat');
		$('.barakah-spektakle .custom-tabs .tabs-title').removeClass('is-active');
		$(this).addClass('is-active');
		$('.barakah-spektakle .art-item').each(function () {
			if (!$(this).hasClass(slug)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		})
	})

	$('.custom-tabs-barakah .tabs-title').on('click', function () {
		let slug = $(this).attr('data-slug-cat');
		$('.custom-tabs-barakah .tabs-title').removeClass('is-active');
		$(this).addClass('is-active');
		$('.content-tab').each(function () {
			if (!$(this).hasClass(slug)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		})
	});

	$('.block-tabs-infra__title').on('click', function () {
		let slug = $(this).attr('data-slug-cat');
		$('.block-tabs-infra__title').removeClass('is-active');
		$(this).addClass('is-active');
		$('.content-block-infra').each(function () {
			if (!$(this).hasClass(slug)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		})
	});


	let lg = $('.block-tabs .block-gallery');
	if (lg.length >= 1) {
		lg.lightGallery({
			mode: "lg-fade",
			controls: true,
			counter: false,
			enableDrag: false,
			enableSwipe: true,
			selector: '.block-gallery__img'
		});

		lg.on("onAfterOpen.lg", function () {
			$("body").addClass("overflow");
		});
		lg.on("onCloseAfter.lg", function () {
			$("body").removeClass("overflow");
		});
	}

	let lgInfra = $('.gallery-infra');
	if (lgInfra.length >= 1) {
		lgInfra.lightGallery({
			mode: "lg-fade",
			controls: true,
			counter: false,
			enableDrag: false,
			enableSwipe: true,
			selector: '.gallery-infra__link'
		});

		lgInfra.on("onAfterOpen.lg", function () {
			$("body").addClass("overflow");
		});
		lgInfra.on("onCloseAfter.lg", function () {
			$("body").removeClass("overflow");
		});
	}


	let dates = [];
	if ($('.date-event-post').length >= 1) {
		$('.date-event-post').each(function () {
			dates.push($(this).attr('data-date-event'));
		});
	}

	let calendarRepertuar = $('.calendar-repertuar');

	let calSingleSpekt = $('#datepicker-single-spektakle');

	if (calendarRepertuar.length >= 1) {
		calendarRepertuar.multiDatesPicker({
			dayNamesMin: ["ND", "PN ", "WT", "ŚR", "CZW", "PT", "SB"],
			firstDay: 1,
			nextText: ">",
			dateFormat: "d/m/y",
			addDates: dates,
			prevText: "<",
			onSelect: function (dataText) {
				if ($(window).width() >= 1024) {
					$(".form-event__input").val(dataText);
					$('.form-event').submit();
				} else {
					$(this).addClass('show-list');
				}
				$(this).multiDatesPicker('addDates', dates);
				setTimeout(function () {
					addListSpektakle();
				}, 100);

			},
			onChangeMonthYear: function (year, month) {
				let arr = {
					'year': year,
					'month': month,
				};
				$('.block-left-post').addClass('event-click');
				$('.calendar-repertuar').addClass('event-click');
				$('.load').addClass('event-click');
				let data = {
					action: "on_change_month_event",
					date: arr,
				}
				$.ajax({
					type: "POST",
					url: themeVars.ajaxurl,
					data: data,
					success: function (data) {
						console.log('secess');
						$('.block-left-post').html(data);
						if ($('.block-left-post a').length < 1) {
							$('.text-not-found').css({display: 'block'});
						}
						setTimeout(function () {
							$('.block-left-post').removeClass('event-click');
							$('.calendar-repertuar').removeClass('event-click');
							$('.load').removeClass('event-click');
							$('html, body').animate({
								scrollTop: $(".block-left-post").offset().top
							}, 1000);
							addListSpektakle();
						}, 500);
						onClickOpenTab();
					},
					error: function (error, status, errorText) {
						if ($('.block-left-post a').length < 1) {
							$('.text-not-found').css({display: 'block'});
						}
						console.log(error);
						console.log(status);
						console.log(errorText);
					},
				});
			},

		});

		$("html").on("click", function () {
			$(".calendar-repertuar").removeClass("show-list");
		});
	}
	let defDate = $('.default-date').attr('data-default-date');
	let today = new Date();

	if (calSingleSpekt.length >= 1) {
		calSingleSpekt.multiDatesPicker({
			dayNamesMin: ["ND", "PN ", "WT", "ŚR", "CZW", "PT", "SB"],
			firstDay: 1,
			nextText: ">",
			dateFormat: "d/m/y",
			addDates: dates,
			defaultDate: defDate ? defDate : today,
			prevText: "<",
			onSelect: function (dataText) {
				if ($(window).width() >= 1024) {
					$(".form-event__input").val(dataText);
				} else {
					$(this).addClass('show-list');
				}
				$(this).multiDatesPicker('addDates', dates);
				setTimeout(function () {
					addListSpektakle();
				}, 100);
			},
			onChangeMonthYear: function () {
				setTimeout(function () {
					addListSpektakle();
				}, 100);
			},

		});
	}

	function addListSpektakle() {
		if ($('.ui-state-highlight').length >= 1) {
			$('.ui-state-highlight').each(function () {
				let monthItem = Number($(this).attr('data-month')) + 1,
					yearItem = $(this).attr('data-year'),
					dayItem = $(this).find('a').text();
				if (monthItem && yearItem && dayItem) {
					let elem = $(this);
					let userDate = dayItem + '/' + monthItem + '/' + yearItem;
					let dateFormating = moment(userDate, "D/M/YYYY").format("DD/MM/YY");
					let addOnce = true;

					$('.date-event-post').each(function () {
						if (dateFormating == $(this).attr('data-date-event')) {
							if (addOnce) {
								elem.append("<ul class='block-list-spekt'></ul>");
								elem.addClass('this-item-have-list');
								addOnce = false;
							}
							let hrefEvent = $(this).attr('data-href-event'),
								nameEvent = $(this).attr('data-event-name'),
								timeEvent = ($(this).attr('data-time-event') != undefined) ? $(this).attr('data-time-event') : '',
								datEv = $(this).attr('data-date-event');
							elem.find('.block-list-spekt').append('<li><span>' + timeEvent + '</span><a data-event="' + datEv + '" href="' + hrefEvent + '">' + nameEvent + ' </a></li>');
						}
					});
				}
			})
			$('.block-list-spekt a').on('click', function () {
				window.location.href = $(this).attr('href');
				localStorage.setItem('date-event', $(this).attr('data-event'));
			});
		}

		if ($('.ui-datepicker-calendar').length >= 1) {
			$('.ui-datepicker-calendar td').each(function () {
				if (!$(this).hasClass('this-item-have-list')) {
					$(this).addClass('not-have-list');
				}
			});
		}
	}

	$('.event-date-storage').on('click', function () {
		localStorage.setItem('date-event', $(this).attr('data-event'));
	});

	addListSpektakle();

	$('.form-event').on('submit', function (e) {
		e.preventDefault();
		$('.block-left-post').addClass('event-click');
		$('.calendar-repertuar').addClass('event-click');
		$('.load').addClass('event-click');
		let data = {
			action: "find_event_date",
			date: $(this).serialize(),
		}
		$.ajax({
			type: "POST",
			url: themeVars.ajaxurl,
			data: data,
			success: function (data) {
				console.log('secess');
				$('.block-left-post').html(data);
				if ($('.block-left-post a').length < 1) {
					$('.text-not-found').css({display: 'block'});
				}
				setTimeout(function () {
					$('.block-left-post').removeClass('event-click');
					$('.calendar-repertuar').removeClass('event-click');
					$('.load').removeClass('event-click');
					$('html, body').animate({
						scrollTop: $(".block-left-post").offset().top
					}, 1000);
				}, 100);
				onClickOpenTab();
			},
			error: function (error, status, errorText) {
				console.log(error);
				console.log(status);
				console.log(errorText);
			},
		});
	})


	if ($('.section-home-slider__block').length >= 1) {
		$('.section-home-slider__block').slick({
			dots: true,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			arrows: false,
			autoplay: true,
			autoplaySpeed: 2000,
			pauseOnFocus: false,
			pauseOnHover: false,
		});
	}

	$('.img-right-column img').wrap('<div class="yellow-block-right">');
	$('.img-left-column img').wrap('<div class="yellow-block-left">');

	if ($('.container-gallery .block-gallery').length >= 1) {
		$('.container-gallery .block-gallery').slick({
			dots: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 7,
			slidesToScroll: 3,
			cssEase: 'linear',
			arrows: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 375,
					settings: {
						slidesToShow: 2
					}
				}
			]
		});
	}


	$(window).resize(function () {
		if ($('.height-js .link-post').length >= 1) {
			let heightColumn = $('.height-js .link-post').height();
			$('.default-js-height').css({height: heightColumn});
		}
		let heightHeader = $('.header').height();
		let heightHeaderBrand = $('.height-logo').height();
		let wind = $(this).width();
		let paddingTopHeader = 0;
		if (wind > 956) {
			paddingTopHeader = 30;
		} else {
			paddingTopHeader = 80;
		}
		if (heightHeader < heightHeaderBrand) {
			$('.height-padding-top').css({paddingTop: heightHeaderBrand + paddingTopHeader + 'px'});
		} else {
			$('.height-padding-top').css({paddingTop: heightHeaderBrand + paddingTopHeader + 'px'});
		}

		if (wind > 922) {
			let heightNav = $('.padding-top-js').height();
			let newTopPadding = (heightHeaderBrand / 2) - (heightNav / 2);
			$('.padding-top-js').css({paddingTop: newTopPadding});
		} else {
			$('.padding-top-js').css({paddingTop: 0});
		}


		if ($($('.btn-burger').length >= 1)) {
			let top = $('.btn-burger').position();
			let left = $('.btn-burger').position();
			$('.menu-main-menu-container').css({top: left.top, left: top.left});
		}
	});


	$('.mob-nav .menu-item-has-children').each(function () {
		$(this).append('<button class="button-arrow"></button>')
	});
	$('.btn-burger').on('click', function () {
		$('.menu-main-menu-container').toggleClass('show');
		$(this).toggleClass('open');
	})
	// $('.current-menu-parent .dropdown').addClass('show');
	// $('.current-menu-parent .button-arrow').addClass('clicked');

	if (windRady >= 1024) {
		$(".menu-item-has-children").hover(function () {
			$(this).find('.dropdown').toggleClass("show");
			$(this).find('.button-arrow').toggleClass('clicked');
		});
	} else {
		$('.button-arrow').on('click', function () {
			if ($(this).prev('.dropdown').hasClass('show')) {
				$(this).prev('.dropdown').removeClass('show');
				$(this).removeClass('clicked');
			} else {
				$('.dropdown.show').each(function () {
					$(this).removeClass('show');
				});
				$('.clicked').each(function () {
					$(this).removeClass('clicked');
				});
				$(this).addClass('clicked');
				$(this).prev('.dropdown').addClass('show');
			}
		})
	}

});



// WEBPACK FOOTER //
// ./scripts/main.js